import ky from "ky";
import { getAuthToken } from "./auth";
import { useActAsStore, isActAsActive } from "@/stores/act-as-store";

const apiClient = ky.create({
  prefixUrl: import.meta.env.VITE_API_URL ?? "http://localhost:8000",
  retry: { limit: 2, methods: ["get"] },
  hooks: {
    beforeRequest: [
      async (request) => {
        const token = await getAuthToken();
        request.headers.set("Authorization", `Bearer ${token}`);
        // Inject X-Act-As-User when an admin is actively impersonating a
        // target user. Expired entries are filtered by isActAsActive; see
        // also the afterResponse hook which auto-clears on server-side
        // rejection.
        //
        // SKIP admin endpoints — those are admin-as-admin operations
        // (start/stop impersonation, look up users, audit activity). The
        // backend's get_current_user dependency now default-rejects the
        // header, so admin endpoints called during an act-as session would
        // 403 if we didn't strip the header here.
        const url = new URL(request.url);
        const isAdminPath = url.pathname.startsWith("/api/admin/");
        const state = useActAsStore.getState();
        if (
          !isAdminPath &&
          isActAsActive(state) &&
          state.actingAsUserId
        ) {
          request.headers.set("X-Act-As-User", state.actingAsUserId);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        if (response.status === 403) {
          try {
            const body = await response.clone().json();
            if (
              body &&
              (body.detail === "act_as_expired" ||
                body.detail === "act_as_ended")
            ) {
              useActAsStore.getState().clearActingAs();
            }
          } catch {
            // Non-JSON body — nothing to key off; ignore silently.
          }
        }
        return response;
      },
    ],
  },
});

export default apiClient;
